(() => {
  const grid = document.getElementById('ProductGridContainer');
  if (!grid || !grid.querySelector('[data-dx-collection-default-sort]')) return;

  const storageKey = 'dongxi:collection-return:v2';
  const historyKey = 'dongxiCollectionReturnEntry';
  const maxAge = 2 * 60 * 60 * 1000;
  const maxEntries = 20;
  let departure = null;
  let quickAddOrigin = null;
  let userSnapshot = null;
  let userIsBrowsing = false;
  let snapshotFrame = null;
  let stopRestoring = () => {};

  const plainState = (state) => state === null || (typeof state === 'object' &&
    (Object.getPrototypeOf(state) === Object.prototype || Object.getPrototypeOf(state) === null));

  const entryId = () => {
    try {
      const state = history.state;
      return plainState(state) && typeof state?.[historyKey] === 'string' ? state[historyKey] : null;
    } catch {
      return null;
    }
  };

  const ensureEntryId = () => {
    try {
      const state = history.state;
      if (!plainState(state) || (state && Object.hasOwn(state, historyKey) && typeof state[historyKey] !== 'string') ||
        (state && Object.hasOwn(state, 'searchParams') && typeof state.searchParams !== 'string')) return null;
      if (entryId()) return entryId();
      const id = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
      // Dawn's popstate handler expects searchParams whenever state is non-null.
      history.replaceState({ searchParams: window.location.search.slice(1), ...state, [historyKey]: id }, '', window.location.href);
      return entryId() === id ? id : null;
    } catch {
      return null;
    }
  };

  const productPath = (href) => {
    try {
      const url = new URL(href, window.location.href);
      return url.origin === window.location.origin && /\/products\/[^/]+\/?$/.test(url.pathname)
        ? url.pathname
        : null;
    } catch {
      return null;
    }
  };

  const readPositions = () => {
    try {
      const entries = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(entries)) return [];
      const now = Date.now();
      return entries.filter((entry) => entry && typeof entry.entryId === 'string' && typeof entry.url === 'string' && productPath(entry.product) &&
        Number.isFinite(entry.y) && entry.y >= 0 && Number.isFinite(entry.offset) &&
        Number.isFinite(entry.time) && now - entry.time >= 0 && now - entry.time < maxAge)
        .sort((a, b) => b.time - a.time).slice(0, maxEntries);
    } catch {
      return [];
    }
  };

  const savePosition = (entry) => {
    try {
      const entries = readPositions().filter((item) => item.entryId !== entry.entryId || item.url !== entry.url);
      sessionStorage.setItem(storageKey, JSON.stringify([{ ...entry, time: Date.now() }, ...entries].slice(0, maxEntries)));
    } catch {
      // Storage failures leave normal links and native history usable.
    }
  };

  const findCard = (product) => {
    const link = [...grid.querySelectorAll('#product-grid > .grid__item a[href]')]
      .find((item) => productPath(item.href) === product && !item.closest('quick-add-modal, modal-dialog, dialog, [role="dialog"]'));
    return link?.closest('#product-grid > .grid__item');
  };

  // Only refresh an already recorded entry after actual user input. This does not
  // create recovery state for newly visited categories or record native auto-scroll.
  const rememberUserPosition = () => {
    const id = entryId();
    const entry = readPositions().find((item) => item.entryId === id && item.url === window.location.href);
    if (!entry) {
      userSnapshot = null;
      return;
    }
    const card = findCard(entry.product);
    userSnapshot = { ...entry, y: window.scrollY, offset: card ? card.getBoundingClientRect().top : entry.offset };
  };
  const interactionEvents = ['pointerdown', 'touchstart', 'wheel', 'keydown', 'input'];
  interactionEvents.forEach((name) => document.addEventListener(name, () => {
    userIsBrowsing = true;
    rememberUserPosition();
  }, { capture: true, passive: true }));
  window.addEventListener('scroll', () => {
    if (!userIsBrowsing || snapshotFrame !== null) return;
    snapshotFrame = requestAnimationFrame(() => {
      snapshotFrame = null;
      rememberUserPosition();
    });
  }, { passive: true });

  document.addEventListener('click', (event) => {
    departure = null;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    // Dawn moves quick-add modals to document.body. Keep the source card's position
    // before focus/overflow changes, without treating opening the picker as navigation.
    const modalOpener = event.target.closest?.('modal-opener[data-modal]');
    if (modalOpener && grid.contains(modalOpener)) {
      const card = modalOpener.closest('#product-grid > .grid__item');
      const button = modalOpener.querySelector('button[data-product-url]');
      if (card && button) quickAddOrigin = {
        modalId: modalOpener.getAttribute('data-modal')?.slice(1),
        product: productPath(button.getAttribute('data-product-url')),
        url: window.location.href, card, y: window.scrollY, offset: card.getBoundingClientRect().top,
      };
    }

    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) return;
    const product = productPath(link.href);
    if (!product) return;

    let card = grid.contains(link) ? link.closest('#product-grid > .grid__item') : null;
    let origin = null;
    const modal = link.closest('quick-add-modal, modal-dialog.quick-add-modal');
    if (modal) {
      const opener = modal.openedBy;
      if (!opener || !grid.contains(opener) || productPath(opener.getAttribute('data-product-url')) !== product) return;
      card = opener.closest('#product-grid > .grid__item');
      if (quickAddOrigin?.modalId === modal.id && quickAddOrigin.product === product &&
        quickAddOrigin.url === window.location.href && quickAddOrigin.card === card) origin = quickAddOrigin;
    } else if (link.closest('modal-dialog, dialog, [role="dialog"]')) return;
    if (!card) return;
    const id = ensureEntryId();
    if (!id) return;

    const position = {
      entryId: id, url: window.location.href, product,
      y: origin ? origin.y : window.scrollY,
      offset: origin ? origin.offset : card.getBoundingClientRect().top,
      time: Date.now(),
    };
    departure = { position, modal };
    // Persist before the navigation commits. pagehide can see a different active
    // history entry and may arrive much later on a slow product response.
    savePosition(position);
  });

  window.addEventListener('pagehide', () => {
    stopRestoring();
    if (snapshotFrame !== null) cancelAnimationFrame(snapshotFrame);
    snapshotFrame = null;
    if (departure) {
      savePosition(departure.position);
      // Close the source picker before bfcache freezes it, so Back shows the list.
      departure.modal?.hide?.(true);
    } else if (userSnapshot) {
      // Preserve the user's later browsing position instead of reusing an older click.
      savePosition(userSnapshot);
    }
    // No-input Forward/Back retains its entry-specific record for another traversal.
    departure = null;
  });

  window.addEventListener('pageshow', (event) => {
    departure = null;
    userSnapshot = null;
    userIsBrowsing = false;
    stopRestoring();
    const navigationType = performance.getEntriesByType?.('navigation')[0]?.type;
    if (!event.persisted && navigationType !== 'back_forward') return;

    let stopped = false;
    let entry = null;
    let waitingForVisibility = false;
    let visibilityTimer = null;
    const visibilityDeadline = Date.now() + maxAge;
    const url = window.location.href;
    const timers = [];
    const frames = [];
    const stop = () => {
      stopped = true;
      timers.forEach(clearTimeout);
      frames.forEach(cancelAnimationFrame);
      interactionEvents.forEach((name) => document.removeEventListener(name, stop, true));
      window.removeEventListener('popstate', onHistoryChange);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (visibilityTimer !== null) clearTimeout(visibilityTimer);
    };
    const waitUntilVisible = () => {
      timers.forEach(clearTimeout);
      frames.forEach(cancelAnimationFrame);
      timers.length = 0;
      frames.length = 0;
      if (waitingForVisibility) return;
      waitingForVisibility = true;
      document.addEventListener('visibilitychange', onVisibilityChange);
      const deadline = entry ? Math.min(visibilityDeadline, entry.time + maxAge) : visibilityDeadline;
      visibilityTimer = setTimeout(stop, Math.max(0, deadline - Date.now()));
    };
    const restore = () => {
      if (stopped) return;
      if (window.location.href !== url) return stop();
      const id = entryId();
      if (entry && entry.entryId !== id) return stop();
      // pageshow precedes state deserialization/native scroll in some traversals.
      // Resolve identity only now, after a task/frame; missing state can retry briefly.
      if (!entry && id) entry = readPositions().find((item) => item.entryId === id && item.url === url);
      if (document.visibilityState === 'hidden') return waitUntilVisible();
      if (!entry || grid.querySelector('.collection.loading')) return;
      const card = findCard(entry.product);
      const top = card ? window.scrollY + card.getBoundingClientRect().top - entry.offset : entry.y;
      const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      const target = Math.min(maximum, Math.max(0, top));
      if (Math.abs(window.scrollY - target) > 3) window.scrollTo({ top: target, behavior: 'instant' });
    };
    const onHistoryChange = () => {
      if (window.location.href !== url || (entry && entryId() !== entry.entryId)) return stop();
      frames.push(requestAnimationFrame(restore));
    };
    const onVisibilityChange = () => {
      if (document.visibilityState !== 'visible' || stopped) return;
      waitingForVisibility = false;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (visibilityTimer !== null) clearTimeout(visibilityTimer);
      visibilityTimer = null;
      scheduleChecks();
    };
    stopRestoring = stop;
    interactionEvents.forEach((name) => document.addEventListener(name, stop, { capture: true, passive: true }));
    window.addEventListener('popstate', onHistoryChange);

    // Check bfcache too: correct native restoration causes no custom scroll; a lost
    // position is repaired. Never disable native restoration or fight user input.
    const scheduleChecks = () => {
      timers.push(setTimeout(() => {
        frames.push(requestAnimationFrame(() => {
          if (stopped) return;
          restore();
          if (stopped || waitingForVisibility) return;
          [80, 180, 360, 720].forEach((delay) => timers.push(setTimeout(restore, delay)));
          timers.push(setTimeout(stop, 1000));
        }));
      }, 0));
    };
    scheduleChecks();
  });
})();
